import {AlertIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {ForYouItem} from '../shared/ForYouItem'
import {useMergeabilityData} from './use-mergeability-data'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {hasUnhandledMergeBlocker} from './merge-blocked-visibility'
import {useGoToMergeBox} from '../../mergebox/use-go-to-mergebox'
import {usePullRequestAnalytics} from '../../../../hooks/use-pull-request-analytics'

// Catch-all "Needs attention" item shown to the author when the merge is blocked
// for a reason not covered by a more specific action item (e.g. a failing
// ruleset rule, an unmet merge condition, or an authorization policy).
export function MergeBlocked() {
  const data = useMergeabilityData()
  const goToMergeBox = useGoToMergeBox()
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()

  if (!data) {
    return null
  }

  const {blockedSection, mergeBoxPullRequest, isClosedOrMerged} = data
  const {sectionStatus, failingConditionsAndRules} = blockedSection

  if (
    isClosedOrMerged ||
    mergeBoxPullRequest.isDraft ||
    sectionStatus === 'PASSED' ||
    !hasUnhandledMergeBlocker(failingConditionsAndRules)
  ) {
    return null
  }

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={AlertIcon} variant="danger" />}
      title="Merge is blocked"
      itemName="merge-blocked"
      description={undefined}
      actionSlot={
        <Button
          type="button"
          size="small"
          onClick={event => {
            sendPullRequestAnalyticsEvent('overview.for_you_item_action', 'OVERVIEW_FOR_YOU_ITEM', {
              item_name: 'merge-blocked',
              action_name: 'view_merge_status',
            })
            goToMergeBox(event.currentTarget)
          }}
        >
          View merge status
        </Button>
      }
    />
  )
}
